
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'page-details-ui',
  currentProjectVersion: 'static-1.15285',
  depVersions: {
  "page-details-ui": "static-1.15285",
  "ai-components-ui-library": "static-1.4977",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3045",
  "content-management-data-lib": "static-1.3661",
  "content-management-details-lib": "static-1.24080",
  "content-management-restrictions-lib": "static-1.3411",
  "crm-object-map": "static-1.1524",
  "data-fetching-client": "static-1.8215",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.644",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.3679",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6620",
  "hub-http": "static-1.4807",
  "hub-http-shared-msw-handlers": "static-1.6842",
  "hubspot-dlb": "static-2.1317",
  "HubStyleTokens": "static-2.10104",
  "I18n": "static-7.1370",
  "jasmine-runner": "static-1.5009",
  "page-lib": "static-1.15229",
  "quartz": "static-1.5368",
  "react-dlb": "static-1.51",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-router-dom": "static-5.26",
  "reporting-dlb": "static-1.53856",
  "reporting-testing-lib": "static-1.2873",
  "settings-ui-lib": "static-1.11177",
  "ui-addon-draggable": "static-1.4362",
  "video-reports-lib": "static-1.28937",
  "webpack-env": "static-1.54",
  "analytics-tools-lib": "static-1.70162",
  "asset-actions-lib": "static-1.38785",
  "attribution-lib": "static-1.36941",
  "campaigns-lib": "static-1.21517",
  "collaboration-sidebar": "static-1.51572",
  "content-intel-content-details-optimize-panel": "static-1.6870",
  "content-management-actions-lib": "static-1.21680",
  "ContentData": "static-1.62646",
  "ContentComponents": "static-2.65527",
  "ContentUtils": "static-1.62569",
  "customer-data-filters": "static-1.46896",
  "customer-data-objects": "static-1.6201",
  "customer-data-properties": "static-1.44974",
  "customer-data-property-utils": "static-1.6537",
  "customer-data-reference-ui-components": "static-1.11598",
  "error-messaging-js": "static-1.3898",
  "ExportDialog": "static-6.9013",
  "file-manager-components": "static-1.17744",
  "foundations-assets": "static-1.3530",
  "foundations-components": "static-1.5780",
  "foundations-theming": "static-1.2927",
  "hubspot-apollo-client": "static-1.3439",
  "hubspot-url-utils": "static-1.2969",
  "immutable": "static-2.19",
  "marketing-contacts-lib": "static-1.7748",
  "object-builder-ui-client": "static-1.41160",
  "onboarding-tours": "static-1.13918",
  "PortalIdParser": "static-2.272",
  "property-translator": "static-1.3989",
  "quartz-core": "static-1.4587",
  "quick-fetch": "static-1.2772",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15216",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-action-components": "static-1.35518",
  "reporting-data": "static-1.60938",
  "reporting-plugins": "static-1.6380",
  "reporting-ui-components": "static-2.58219",
  "reporting-visualizations": "static-1.53018",
  "reselect": "static-2.16",
  "sanitize-text": "static-1.6805",
  "segments-lib": "static-1.26527",
  "SharedI18nStrings": "static-1.162",
  "social-composer-lib": "static-1.52744",
  "ui-addon-emoji-picker": "static-1.8533",
  "ui-addon-form-validation": "static-1.9642",
  "ui-addon-i18n": "static-1.9530",
  "ui-addon-iframeable": "static-1.7513",
  "ui-addon-react-router-dom": "static-1.8229",
  "ui-addon-teams": "static-1.19497",
  "ui-addon-upgrades": "static-9.15764",
  "ui-asset-management-lib": "static-1.8812",
  "ui-business-units-lib": "static-1.7491",
  "ui-forms-editor-automation-lib": "static-1.58584",
  "ui-memberships-settings-lib": "static-1.27611",
  "ui-product-approvals": "static-1.23370",
  "ui-shepherd-react": "static-3.8661",
  "UIComponents": "static-3.7053",
  "usage-tracker": "static-1.6081",
  "usage-tracker-container": "static-1.6071",
  "enviro": "static-4.293",
  "hs-promise-rejection-tracking": "static-1.3967",
  "raven": "static-3.4440",
  "raven-hubspot": "static-1.4747",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.8343",
  "styled-components": "static-2.40",
  "bend-plugin-trellis-migration": "static-1.2287",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1645",
  "quartz-webpack": "static-1.1592",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14803",
  "copilot-toolkit": "static-1.5570",
  "cssUtils": "static-1.456",
  "foundations-theming-base": "static-1.1912",
  "hs-story-utils": "static-1.8005",
  "HubStyle": "static-2.10413",
  "icons": "static-2.591",
  "msw": "static-1.39",
  "react-utils": "static-2.4173",
  "rpc-client-utils": "static-1.3344",
  "sanitize": "static-1.2984",
  "sassPrefix": "static-1.129",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.805",
  "usage-tracker-core": "static-1.5931",
  "graphql": "static-1.58",
  "react-dnd-compat": "static-1.3253",
  "report-customization-components": "static-1.8192",
  "reporting-enablement": "static-1.16292",
  "avatar-components": "static-1.1018",
  "crm-links": "static-1.4729",
  "crm-message-bus": "static-1.35875",
  "crm-object-search-query-utilities": "static-1.5889",
  "customer-data-filters-ui": "static-1.33082",
  "framework-data-schema-resolvers": "static-1.5473",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6928",
  "framework-data-table": "static-2.8228",
  "inbound-db-meta-service-client": "static-1.2621",
  "HeadJS": "static-2.563",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1731",
  "testing-library": "static-1.120",
  "ts-schema": "static-1.2985",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.2965",
  "quartz-core-utils": "static-1.2235",
  "StyleGuideUI": "static-3.453",
  "reporting-client-types": "static-1.1767",
  "flux-actions": "static-1.266",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.8836",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9082",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "react-flip-move": "static-1.46",
  "reference-resolvers": "static-1.6766",
  "marketing-platform-lib": "static-1.5270",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "transmute": "static-2.29",
  "user-context": "static-1.3770",
  "atom": "static-1.3860",
  "FormUrlGenerator": "static-2.3328",
  "integrations-lib": "static-1.9822",
  "property-description-translator": "static-1.2453",
  "reference-resolvers-lite": "static-1.6562",
  "reporting-snowflake": "static-1.49562",
  "self-service-api": "static-1.8805",
  "ui-addon-avatars": "static-2.8051",
  "campaigns-build-lib": "static-1.6919",
  "crm-pipelines-api-client-types": "static-1.2959",
  "customer-data-objects-ui-components": "static-1.11500",
  "hs-promise-utils": "static-1.4128",
  "superstore": "static-1.3395",
  "chatspot-widget-iframe": "static-1.14798",
  "frontend-preferences-client": "static-1.6491",
  "hs-lodash": "static-4.45",
  "content-intel-shared": "static-1.7146",
  "cms-field-types": "static-1.3395",
  "FileManagerLib": "static-1.33385",
  "video-data-lib": "static-1.28761",
  "blueimp-md5": "static-1.8",
  "codemirror": "static-5.69",
  "content-embed-lib": "static-1.5970",
  "data-token-picker": "static-1.13793",
  "data-token-views": "static-1.13774",
  "FileManagerCore": "static-1.33244",
  "forms-utils-lib": "static-1.9946",
  "growth-payments-core": "static-1.20566",
  "integrations-error-boundary-lib": "static-1.7236",
  "media-bridge-lib": "static-1.16413",
  "payment-link-components": "static-1.17860",
  "payments-embed-points-lib": "static-1.8958",
  "products-ui-components": "static-1.34748",
  "react-beautiful-dnd": "static-1.13",
  "react-codemirror": "static-1.9208",
  "react-select-plus": "static-1.65",
  "react-tinymce": "static-1.49932",
  "react-virtualized": "static-2.73",
  "rich-text-lib": "static-1.17146",
  "simple-menus-core": "static-1.13321",
  "simple-menus-lib": "static-1.14839",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.49058",
  "tinymce-data": "static-1.35142",
  "tinymce-plugins": "static-1.52172",
  "tinymce-themes": "static-1.51027",
  "videoconference-integration-components": "static-1.4724",
  "content-icons-ui": "static-1.1863",
  "customer-data-ui-utilities": "static-1.8351",
  "deep-diff": "static-1.5",
  "framework-builder-read-service-client": "static-1.2906",
  "framework-data-schema-quick-fetch": "static-1.5378",
  "inbound-db-properties-service-client": "static-1.2797",
  "lodash": "static-4.7",
  "commerce-products-lib": "static-1.4226",
  "conditional-properties-service-client": "static-1.2770",
  "enrichment-properties-lib": "static-1.8966",
  "external-options-client-types": "static-1.2934",
  "google-libphonenumber": "static-1.11",
  "inbounddb-objects-service-types": "static-1.3062",
  "pipeline-validation-client-types": "static-1.2723",
  "bend-plugin-foundations-components": "static-1.2048",
  "floating-ui": "static-1.28",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "bend-plugin-foundations-theming": "static-1.1410",
  "apollo-link-hub-http": "static-2.3402",
  "getting-started-shared-tasks": "static-1.11475",
  "growth-data-modal": "static-1.3809",
  "growth-onboarding-confetti": "static-1.1721",
  "navigation-components": "static-1.13518",
  "ui-shepherd-tracker": "static-1.6042",
  "ui-universal-auth": "static-1.7412",
  "dispatcher": "static-1.111",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.635",
  "hubspotter-http": "static-1.3407",
  "hubspotter-http-shared-msw-handlers": "static-1.6840",
  "mobile-manifest-mixins": "static-1.334",
  "platform-navigation-bootstrap": "static-1.11008",
  "csstype": "static-1.38",
  "content-assistance-lib": "static-1.6076",
  "dashboard-lib": "static-1.75031",
  "share-with-third-party-component-lib": "static-1.7257",
  "immer": "static-1.33",
  "campaign-roi-lib": "static-1.2104",
  "reporting-reports": "static-1.60625",
  "account-and-billing-components": "static-1.16068",
  "growth-feature-usage-components": "static-1.4107",
  "foundations-components-test-utils": "static-1.3265",
  "magpie-lib": "static-1.4296",
  "navigation-messaging": "static-1.2845",
  "feature-store-service-types": "static-1.3284",
  "growth-monetization-service-types": "static-1.3291",
  "salesImages": "static-1.498",
  "upgrade-management-service-types": "static-1.3275",
  "timezone-utils": "static-2.3879",
  "automation-contextual-components": "static-1.12867",
  "automation-ui-source-apps": "static-1.12421",
  "automation-ui-template": "static-1.39664",
  "automation-ui-types": "static-1.13339",
  "forms-ai-lib": "static-1.2025",
  "redux-actions": "static-3.7",
  "ui-addon-automation-embed": "static-1.12056",
  "ui-forms-components": "static-1.7941",
  "feedback-loader": "static-1.26223",
  "data-quality-ui-library": "static-1.7376",
  "html-to-image": "static-1.29",
  "laboratory-lib": "static-3.5873",
  "ui-addon-opt": "static-4.7266",
  "location-customization-utils-lib": "static-1.3416",
  "fast-json-stable-stringify": "static-1.4",
  "customer-data-filters-ui-msw-helpers": "static-1.15514",
  "persist-promise": "static-1.2361",
  "customer-data-associations": "static-1.5819",
  "redux-toolkit": "static-1.7",
  "getting-started-shared-tasks-store": "static-1.10593",
  "integrations-tracking-lib": "static-1.4082",
  "native-integrations-shared-strings": "static-1.6435",
  "reporting-datasets-permissions-lib": "static-1.6688",
  "FileManagerImages": "static-1.30895",
  "diff-match-patch": "static-1.7",
  "audio-components": "static-1.4220",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.3158",
  "video-components": "static-1.7115",
  "video-embed": "static-1.29604",
  "commerce-analytics-service-client": "static-1.2402",
  "commerce-tours-lib": "static-1.3127",
  "growth-onboarding-reliability": "static-1.3755",
  "sales-checkout-service-client": "static-1.2414",
  "payments-enrollment-embed-lib": "static-1.17042",
  "commerce-shared-components-lib": "static-1.14240",
  "commerce-subscription-lib": "static-1.30494",
  "crm_components": "static-3.86166",
  "crm_data": "static-4.86166",
  "customer-data-tracking": "static-1.5426",
  "browser-eslint": "static-2.57",
  "react-transition-group": "static-1.7",
  "seamless-immutable": "static-7.6",
  "hub-http-contrib": "static-1.1795",
  "interframe": "static-3.3414",
  "ui-addon-sales-email": "static-1.3815",
  "layout-dnd-components": "static-1.10552",
  "layout-dnd-utils": "static-1.9527",
  "NamespacedHubStyle": "static-2.8077",
  "react-immutable-render-mixin": "static-1.9",
  "products-iframe-lib": "static-1.2254",
  "products-ui-components-shared-msw-handlers": "static-1.7227",
  "breeze-intelligence-kit": "static-1.3825",
  "crm-source-interpretation-lib": "static-1.3881",
  "fsm": "static-1.2308",
  "policy-lib": "static-1.5416",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3756",
  "simple-logging-lib": "static-1.1658",
  "platform-infra-nav-components": "static-1.6534",
  "ui-addon-video-player": "static-1.7389",
  "ui-coaching-tips": "static-1.21884",
  "onboarding-scopes": "static-1.5157",
  "account-and-billing-fintech-outages": "static-3.14817",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11703",
  "subscription-experience-data-types": "static-1.10013",
  "transactions-exp-service-client-types": "static-1.11699",
  "growth-feature-usage-data": "static-1.4326",
  "automation-platform-service-types": "static-1.2050",
  "automation-templates-service-types": "static-1.2778",
  "automation-ui-core": "static-2.15275",
  "redux-mock-store": "static-1.8",
  "form-builder-ui": "static-1.7716",
  "crm-record-cards-service-types": "static-1.2636",
  "universal-page-editor-lib": "static-1.1552",
  "immerable": "static-1.2780",
  "social-insights-client-types": "static-1.17246",
  "outpost": "static-1.2954",
  "onboarding-tours-client": "static-1.3126",
  "growth-onboarding-feedback-components": "static-1.5073",
  "marketplace-ui-apps-core": "static-1.12002",
  "stripe-embedded-components": "static-1.4939",
  "commerce-billing-lib": "static-1.14142",
  "commerce-contract-lib": "static-1.5350",
  "commerce-tools-ui-lib": "static-1.5969",
  "conversations-skeleton-state": "static-1.6009",
  "crm_universal": "static-1.20349",
  "customer-data-content": "static-1.24162",
  "crm_schema": "static-3.86202",
  "customer-data-email": "static-1.15512",
  "layout-data-lib": "static-1.7852",
  "multi-currency-client-types": "static-1.2666",
  "sales-views-client-types": "static-1.2964",
  "trellis-story-utils": "static-1.3169",
  "immutable-less": "static-1.3174",
  "developer-experience-shared-components": "static-1.8687",
  "marketplace-ui-client-types": "static-1.10872",
  "marketplace-ui-common": "static-1.13466",
  "ui-addon-integrations-directory-panel": "static-2.6601",
  "ui-extensibility-client-types": "static-1.2816",
  "stripe-connect-js": "static-1.37",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1192",
  "crm-cards-sdk": "static-1.37373",
  "customer-data-rte": "static-1.28452",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-empty-states": "static-1.3783",
  "hubspot-prosemirror": "static-1.13051",
  "InboxConnectUtils": "static-4.9273",
  "payments-post-enroll-local-storage-lib": "static-1.3694",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "SalesContentIndexUI": "static-3.6819",
  "sequences-lib": "static-1.5642",
  "ui-gdpr-components": "static-1.8872",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2918",
  "nav-meta": "static-1.25155",
  "react-window": "static-1.13",
  "amplitude-session-replay-browser": "static-1.6",
  "crm-actions": "static-1.4674",
  "crm-fe-perf": "static-1.21594",
  "draft-content-plugins": "static-1.23773",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18969",
  "knowledge-content-types": "static-1.7617",
  "FireAlarmUi": "static-1.3483",
  "sequences-client-types-lib": "static-1.5498"
},
  depPathPrefixes: {
  "page-details-ui": "/page-details-ui/static-1.15285",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4977",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3045",
  "content-management-data-lib": "/content-management-data-lib/static-1.3661",
  "content-management-details-lib": "/content-management-details-lib/static-1.24080",
  "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.3411",
  "crm-object-map": "/crm-object-map/static-1.1524",
  "data-fetching-client": "/data-fetching-client/static-1.8215",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.644",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.3679",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6620",
  "hub-http": "/hub-http/static-1.4807",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6842",
  "hubspot-dlb": "/hubspot-dlb/static-2.1317",
  "HubStyleTokens": "/HubStyleTokens/static-2.10104",
  "I18n": "/I18n/static-7.1370",
  "jasmine-runner": "/jasmine-runner/static-1.5009",
  "page-lib": "/page-lib/static-1.15229",
  "quartz": "/quartz/static-1.5368",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reporting-dlb": "/reporting-dlb/static-1.53856",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.2873",
  "settings-ui-lib": "/settings-ui-lib/static-1.11177",
  "ui-addon-draggable": "/ui-addon-draggable/static-1.4362",
  "video-reports-lib": "/video-reports-lib/static-1.28937",
  "webpack-env": "/webpack-env/static-1.54",
  "analytics-tools-lib": "/analytics-tools-lib/static-1.70162",
  "asset-actions-lib": "/asset-actions-lib/static-1.38785",
  "attribution-lib": "/attribution-lib/static-1.36941",
  "campaigns-lib": "/campaigns-lib/static-1.21517",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51572",
  "content-intel-content-details-optimize-panel": "/content-intel-content-details-optimize-panel/static-1.6870",
  "content-management-actions-lib": "/content-management-actions-lib/static-1.21680",
  "ContentData": "/ContentData/static-1.62646",
  "ContentComponents": "/ContentComponents/static-2.65527",
  "ContentUtils": "/ContentUtils/static-1.62569",
  "customer-data-filters": "/customer-data-filters/static-1.46896",
  "customer-data-objects": "/customer-data-objects/static-1.6201",
  "customer-data-properties": "/customer-data-properties/static-1.44974",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6537",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11598",
  "error-messaging-js": "/error-messaging-js/static-1.3898",
  "ExportDialog": "/ExportDialog/static-6.9013",
  "file-manager-components": "/file-manager-components/static-1.17744",
  "foundations-assets": "/foundations-assets/static-1.3530",
  "foundations-components": "/foundations-components/static-1.5780",
  "foundations-theming": "/foundations-theming/static-1.2927",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3439",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
  "immutable": "/immutable/static-2.19",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7748",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41160",
  "onboarding-tours": "/onboarding-tours/static-1.13918",
  "PortalIdParser": "/PortalIdParser/static-2.272",
  "property-translator": "/property-translator/static-1.3989",
  "quartz-core": "/quartz-core/static-1.4587",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15216",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-action-components": "/reporting-action-components/static-1.35518",
  "reporting-data": "/reporting-data/static-1.60938",
  "reporting-plugins": "/reporting-plugins/static-1.6380",
  "reporting-ui-components": "/reporting-ui-components/static-2.58219",
  "reporting-visualizations": "/reporting-visualizations/static-1.53018",
  "reselect": "/reselect/static-2.16",
  "sanitize-text": "/sanitize-text/static-1.6805",
  "segments-lib": "/segments-lib/static-1.26527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "social-composer-lib": "/social-composer-lib/static-1.52744",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8533",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9642",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9530",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7513",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8229",
  "ui-addon-teams": "/ui-addon-teams/static-1.19497",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15764",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8812",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7491",
  "ui-forms-editor-automation-lib": "/ui-forms-editor-automation-lib/static-1.58584",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27611",
  "ui-product-approvals": "/ui-product-approvals/static-1.23370",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8661",
  "UIComponents": "/UIComponents/static-3.7053",
  "usage-tracker": "/usage-tracker/static-1.6081",
  "usage-tracker-container": "/usage-tracker-container/static-1.6071",
  "enviro": "/enviro/static-4.293",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
  "raven": "/raven/static-3.4440",
  "raven-hubspot": "/raven-hubspot/static-1.4747",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.8343",
  "styled-components": "/styled-components/static-2.40",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2287",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1645",
  "quartz-webpack": "/quartz-webpack/static-1.1592",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14803",
  "copilot-toolkit": "/copilot-toolkit/static-1.5570",
  "cssUtils": "/cssUtils/static-1.456",
  "foundations-theming-base": "/foundations-theming-base/static-1.1912",
  "hs-story-utils": "/hs-story-utils/static-1.8005",
  "HubStyle": "/HubStyle/static-2.10413",
  "icons": "/icons/static-2.591",
  "msw": "/msw/static-1.39",
  "react-utils": "/react-utils/static-2.4173",
  "rpc-client-utils": "/rpc-client-utils/static-1.3344",
  "sanitize": "/sanitize/static-1.2984",
  "sassPrefix": "/sassPrefix/static-1.129",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.805",
  "usage-tracker-core": "/usage-tracker-core/static-1.5931",
  "graphql": "/graphql/static-1.58",
  "react-dnd-compat": "/react-dnd-compat/static-1.3253",
  "report-customization-components": "/report-customization-components/static-1.8192",
  "reporting-enablement": "/reporting-enablement/static-1.16292",
  "avatar-components": "/avatar-components/static-1.1018",
  "crm-links": "/crm-links/static-1.4729",
  "crm-message-bus": "/crm-message-bus/static-1.35875",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5889",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33082",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5473",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6928",
  "framework-data-table": "/framework-data-table/static-2.8228",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2621",
  "HeadJS": "/HeadJS/static-2.563",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1731",
  "testing-library": "/testing-library/static-1.120",
  "ts-schema": "/ts-schema/static-1.2985",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.2965",
  "quartz-core-utils": "/quartz-core-utils/static-1.2235",
  "StyleGuideUI": "/StyleGuideUI/static-3.453",
  "reporting-client-types": "/reporting-client-types/static-1.1767",
  "flux-actions": "/flux-actions/static-1.266",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.8836",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9082",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "react-flip-move": "/react-flip-move/static-1.46",
  "reference-resolvers": "/reference-resolvers/static-1.6766",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5270",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "transmute": "/transmute/static-2.29",
  "user-context": "/user-context/static-1.3770",
  "atom": "/atom/static-1.3860",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3328",
  "integrations-lib": "/integrations-lib/static-1.9822",
  "property-description-translator": "/property-description-translator/static-1.2453",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6562",
  "reporting-snowflake": "/reporting-snowflake/static-1.49562",
  "self-service-api": "/self-service-api/static-1.8805",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8051",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.6919",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2959",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11500",
  "hs-promise-utils": "/hs-promise-utils/static-1.4128",
  "superstore": "/superstore/static-1.3395",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14798",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6491",
  "hs-lodash": "/hs-lodash/static-4.45",
  "content-intel-shared": "/content-intel-shared/static-1.7146",
  "cms-field-types": "/cms-field-types/static-1.3395",
  "FileManagerLib": "/FileManagerLib/static-1.33385",
  "video-data-lib": "/video-data-lib/static-1.28761",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "codemirror": "/codemirror/static-5.69",
  "content-embed-lib": "/content-embed-lib/static-1.5970",
  "data-token-picker": "/data-token-picker/static-1.13793",
  "data-token-views": "/data-token-views/static-1.13774",
  "FileManagerCore": "/FileManagerCore/static-1.33244",
  "forms-utils-lib": "/forms-utils-lib/static-1.9946",
  "growth-payments-core": "/growth-payments-core/static-1.20566",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7236",
  "media-bridge-lib": "/media-bridge-lib/static-1.16413",
  "payment-link-components": "/payment-link-components/static-1.17860",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8958",
  "products-ui-components": "/products-ui-components/static-1.34748",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-codemirror": "/react-codemirror/static-1.9208",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-tinymce": "/react-tinymce/static-1.49932",
  "react-virtualized": "/react-virtualized/static-2.73",
  "rich-text-lib": "/rich-text-lib/static-1.17146",
  "simple-menus-core": "/simple-menus-core/static-1.13321",
  "simple-menus-lib": "/simple-menus-lib/static-1.14839",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.49058",
  "tinymce-data": "/tinymce-data/static-1.35142",
  "tinymce-plugins": "/tinymce-plugins/static-1.52172",
  "tinymce-themes": "/tinymce-themes/static-1.51027",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4724",
  "content-icons-ui": "/content-icons-ui/static-1.1863",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8351",
  "deep-diff": "/deep-diff/static-1.5",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2906",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5378",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2797",
  "lodash": "/lodash/static-4.7",
  "commerce-products-lib": "/commerce-products-lib/static-1.4226",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2770",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.8966",
  "external-options-client-types": "/external-options-client-types/static-1.2934",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3062",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2723",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2048",
  "floating-ui": "/floating-ui/static-1.28",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1410",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3402",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11475",
  "growth-data-modal": "/growth-data-modal/static-1.3809",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1721",
  "navigation-components": "/navigation-components/static-1.13518",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6042",
  "ui-universal-auth": "/ui-universal-auth/static-1.7412",
  "dispatcher": "/dispatcher/static-1.111",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.635",
  "hubspotter-http": "/hubspotter-http/static-1.3407",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6840",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11008",
  "csstype": "/csstype/static-1.38",
  "content-assistance-lib": "/content-assistance-lib/static-1.6076",
  "dashboard-lib": "/dashboard-lib/static-1.75031",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7257",
  "immer": "/immer/static-1.33",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2104",
  "reporting-reports": "/reporting-reports/static-1.60625",
  "account-and-billing-components": "/account-and-billing-components/static-1.16068",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4107",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3265",
  "magpie-lib": "/magpie-lib/static-1.4296",
  "navigation-messaging": "/navigation-messaging/static-1.2845",
  "feature-store-service-types": "/feature-store-service-types/static-1.3284",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3291",
  "salesImages": "/salesImages/static-1.498",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3275",
  "timezone-utils": "/timezone-utils/static-2.3879",
  "automation-contextual-components": "/automation-contextual-components/static-1.12867",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12421",
  "automation-ui-template": "/automation-ui-template/static-1.39664",
  "automation-ui-types": "/automation-ui-types/static-1.13339",
  "forms-ai-lib": "/forms-ai-lib/static-1.2025",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12056",
  "ui-forms-components": "/ui-forms-components/static-1.7941",
  "feedback-loader": "/feedback-loader/static-1.26223",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7376",
  "html-to-image": "/html-to-image/static-1.29",
  "laboratory-lib": "/laboratory-lib/static-3.5873",
  "ui-addon-opt": "/ui-addon-opt/static-4.7266",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3416",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15514",
  "persist-promise": "/persist-promise/static-1.2361",
  "customer-data-associations": "/customer-data-associations/static-1.5819",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10593",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4082",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6435",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6688",
  "FileManagerImages": "/FileManagerImages/static-1.30895",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "audio-components": "/audio-components/static-1.4220",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.3158",
  "video-components": "/video-components/static-1.7115",
  "video-embed": "/video-embed/static-1.29604",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3127",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3755",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17042",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14240",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30494",
  "crm_components": "/crm_components/static-3.86166",
  "crm_data": "/crm_data/static-4.86166",
  "customer-data-tracking": "/customer-data-tracking/static-1.5426",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-transition-group": "/react-transition-group/static-1.7",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "hub-http-contrib": "/hub-http-contrib/static-1.1795",
  "interframe": "/interframe/static-3.3414",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3815",
  "layout-dnd-components": "/layout-dnd-components/static-1.10552",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9527",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8077",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "products-iframe-lib": "/products-iframe-lib/static-1.2254",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7227",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3825",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3881",
  "fsm": "/fsm/static-1.2308",
  "policy-lib": "/policy-lib/static-1.5416",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3756",
  "simple-logging-lib": "/simple-logging-lib/static-1.1658",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6534",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7389",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.21884",
  "onboarding-scopes": "/onboarding-scopes/static-1.5157",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14817",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11703",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10013",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11699",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4326",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2050",
  "automation-templates-service-types": "/automation-templates-service-types/static-1.2778",
  "automation-ui-core": "/automation-ui-core/static-2.15275",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "form-builder-ui": "/form-builder-ui/static-1.7716",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2636",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1552",
  "immerable": "/immerable/static-1.2780",
  "social-insights-client-types": "/social-insights-client-types/static-1.17246",
  "outpost": "/outpost/static-1.2954",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3126",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5073",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12002",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4939",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14142",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5350",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5969",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6009",
  "crm_universal": "/crm_universal/static-1.20349",
  "customer-data-content": "/customer-data-content/static-1.24162",
  "crm_schema": "/crm_schema/static-3.86202",
  "customer-data-email": "/customer-data-email/static-1.15512",
  "layout-data-lib": "/layout-data-lib/static-1.7852",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2666",
  "sales-views-client-types": "/sales-views-client-types/static-1.2964",
  "trellis-story-utils": "/trellis-story-utils/static-1.3169",
  "immutable-less": "/immutable-less/static-1.3174",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8687",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10872",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13466",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6601",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2816",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1192",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37373",
  "customer-data-rte": "/customer-data-rte/static-1.28452",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3783",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13051",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9273",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3694",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6819",
  "sequences-lib": "/sequences-lib/static-1.5642",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8872",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2918",
  "nav-meta": "/nav-meta/static-1.25155",
  "react-window": "/react-window/static-1.13",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "crm-actions": "/crm-actions/static-1.4674",
  "crm-fe-perf": "/crm-fe-perf/static-1.21594",
  "draft-content-plugins": "/draft-content-plugins/static-1.23773",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18969",
  "knowledge-content-types": "/knowledge-content-types/static-1.7617",
  "FireAlarmUi": "/FireAlarmUi/static-1.3483",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5498"
}
};
